const quantityButtons = document.querySelectorAll(".quantity-selector__button");
const quantityInputs = document.querySelectorAll(".quantity-selector-input");
const colorSwatchButtons = document.querySelectorAll(".color-swatch__item");
const addToCartButton = document.querySelector(".product-form__add-button");

window.addEventListener("DOMContentLoaded", () => {
  const selectedColor = document.querySelector(".product-form__selected-value");
  if (selectedColor) toogleVariantRowsByColor(selectedColor.innerHTML);
});

const observer = new MutationObserver((mutations) => {
  const vectorImageInput = document.querySelector("#_VectorImage");

  const hasChangeValue = mutations.filter(
    (mutation) => mutation.attributeName == "value"
  );
  const uploaderyForm = document.querySelector(".logo-preview_input");
  const logoInput = document.querySelector(".logo-preview_input-element");

  if (vectorImageInput && hasChangeValue && logoInput.value != "") {
    uploaderyForm?.classList.remove("invalid");
  } else {
    uploaderyForm?.classList.add("invalid");
  }
  validateFile();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

function validateFile() {
  const productFormContainer = document.querySelector(".add-to-cart-container");
  const messagesContainer = document.querySelector(".messages-container");
  const successContainer = document.querySelector(".success-container");
  const fileError = document.querySelector(".file-error");
  const addToCartButton = document.querySelector(".product-form__add-button");

  if (hasValidFile()) {
    messagesContainer?.classList.remove("d-none");
    fileError?.classList.add("d-none");
    if (!successContainer.classList.contains("d-none"))
      addToCartButton.removeAttribute("disabled");
  } else {
    messagesContainer?.classList.add("d-none");
    addToCartButton.setAttribute("disabled", "disabled");
    fileError?.classList.remove("d-none");
    if (!fileError)
      productFormContainer.innerHTML +=
        '<small class="error-container file-error">Please attach a valid file.</small>';
  }
}

quantityButtons.forEach((quantityButton) => {
  quantityButton.addEventListener("click", (e) => {
    const actionButton = e.target;
    const quantityInput = actionButton
      .closest(".quantity-selector")
      .querySelector(".quantity-selector-input");

    if (actionButton.classList.contains("add-button")) {
      plusQuantity(quantityInput);
    }

    if (actionButton.classList.contains("minus-button")) {
      minusQuantity(quantityInput);
    }

    validateQuantity(quantityInput);
    calculateTotals();
  });
});

quantityInputs.forEach((quantityInput) => {
  quantityInput.addEventListener("change", (e) => {
    changeQuantity(e.target);
    validateQuantity(e.target);
    calculateTotals();
  });
});

colorSwatchButtons.forEach((colorSwatchButton) => {
  colorSwatchButton.addEventListener("click", (e) => {
    const colorSwatch = e.target;

    checkColorSwatch(colorSwatch);
    toogleVariantRowsByColor(colorSwatch.dataset.color);
    toggleVariantPreview(colorSwatch.dataset.color);
  });
});

function toggleVariantPreview(color) {
  const toHideThumbnail = document.querySelector(
    `.product-gallery__thumbnail.logo-preview.is-shown`
  );
  toHideThumbnail?.classList.remove("is-shown");

  const actualThumbnail = document.querySelector(
    `.product-gallery__thumbnail.logo-preview[data-media-id="logo-preview_${color}"]`
  );
  actualThumbnail?.classList.add("is-shown");
  if (actualThumbnail && typeof actualThumbnail.click === "function")
    actualThumbnail.click();
  const actualImagePreview = document.querySelector(
    `.img-preview_canvas[data-media-id="logo-preview_${color}"]`
  );

  const source = actualImagePreview?.src;
  if (source) actualImagePreview.setAttribute("data-src", source);
}

function toogleVariantRowsByColor(color) {
  const variantRows = document.querySelectorAll(".variant-row");
  let mediaId = null;

  variantRows.forEach((variantRow) => {
    if (variantRow.dataset.options.includes(color)) {
      variantRow.classList.remove("d-none");
      mediaId = variantRow.dataset.variantMedia;
    } else {
      variantRow.classList.add("d-none");
    }
  });

  if (mediaId) {
    const mediaThumbnail = document.querySelector(
      `.product-gallery__thumbnail[data-media-id='${mediaId}']`
    );
    const mediaPreview = document.querySelector(".logo-preview_thumbnail");

    if (mediaThumbnail && !mediaPreview) mediaThumbnail.click();
  }
}

function checkColorSwatch(colorSwatch) {
  const colorTitleLabel = document.querySelector(
    ".product-form__selected-value"
  );

  colorSwatchButtons.forEach((colorSwatchButton) => {
    colorSwatchButton.classList.remove("active");
  });

  colorSwatch.classList.add("active");
  colorTitleLabel.innerHTML = colorSwatch.dataset.color;
}

function hasValidNumbers(value) {
  const numberPattern = /^[0-9]+$/;

  return numberPattern.test(value);
}

function validateQuantity(input) {
  const maxQuantity = parseInt(input.max);
  const stepQuantity = input.dataset.stepQuantity
    ? parseInt(input.dataset.stepQuantity)
    : 1;
  const currentValue = parseInt(input.value);

  if (!hasValidNumbers(currentValue)) input.value = 0;

  if (currentValue > maxQuantity) {
    input.value = maxQuantity - (maxQuantity % stepQuantity);
  }

  if (currentValue < 0) {
    input.value = 0;
  }
}

function changeQuantity(input) {
  const stepQuantity = input.dataset.stepQuantity
    ? parseInt(input.dataset.stepQuantity)
    : 1;
  const stepRemainder = input.value % stepQuantity;

  if (stepRemainder > 0) {
    input.value = parseInt(input.value) + (stepQuantity - stepRemainder);
  }
}

function plusQuantity(input) {
  input.value = parseInt(input.value) + getQuantityToUpdate(input);
}

function minusQuantity(input) {
  input.value -= getQuantityToUpdate(input);
}

function getQuantityToUpdate(input) {
  const stepQuantity = input.dataset.stepQuantity
    ? parseInt(input.dataset.stepQuantity)
    : 1;
  const stepRemainder = input.value % stepQuantity;
  const quantityToUpdate = stepRemainder > 0 ? stepRemainder : stepQuantity;

  return parseInt(quantityToUpdate);
}

function calculateTotals() {
  const variantRows = document.querySelectorAll(".variant-row");
  const totalUnitsContainer = document.querySelector(".total-units .units");
  const totalPriceContainer = document.querySelector(
    ".total-price .price-value"
  );
  let totalUnits = 0;
  let totalPrices = 0;

  variantRows.forEach((variantRow) => {
    const variantPrice =
      variantRow.querySelector(".price-container").dataset.price;
    const variantQuantity = variantRow.querySelector(
      ".quantity-selector-input"
    );

    if (variantQuantity) {
      totalUnits += parseInt(variantQuantity.value);
      totalPrices += parseFloat(variantPrice) * parseInt(variantQuantity.value);
    }
  });

  if (!variantRows.length) totalUnits = quantityInputs[0].value;

  if (totalUnitsContainer) totalUnitsContainer.innerHTML = totalUnits;
  if (totalPriceContainer)
    totalPriceContainer.innerHTML = `$${totalPrices.toFixed(2)}`;

  validateTotalUnits(totalUnits);

  if (!hasValidFile()) {
    validateFile();
  }
}

function validateTotalUnits(totalUnits) {
  const errorContainer = document.querySelector(
    ".product-block-list__item--info .error-container"
  );
  const successContainer = document.querySelector(
    ".product-block-list__item--info .success-container"
  );
  const addToCartButton = document.querySelector(".product-form__add-button");

  if (totalUnits >= MINIMUM_QUANTITY_TO_BUY) {
    addToCartButton.removeAttribute("disabled");
    errorContainer?.classList.add("d-none");
    successContainer?.classList.remove("d-none");
  } else {
    addToCartButton.setAttribute("disabled", "disabled");
    errorContainer?.classList.remove("d-none");
    successContainer?.classList.add("d-none");
  }
}

function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function hasValidFile() {
  const uploaderyComponent = document.querySelector(".logo-preview_input");
  const vectorImageInput = document.querySelector("#_VectorImage");
  const logoInput = document.querySelector(".logo-preview_input-element");

  // debugger;
  if (REQUIRE_LOGO && uploaderyComponent && !vectorImageInput) return false;
  if (REQUIRE_LOGO && uploaderyComponent && logoInput.value == "") return false;

  return true;
}
